import axios from "axios";
import { API_ROUTES } from "../../routes/UrlList";
import { setAnnouncementList, setCount, setSlidingAnnouncementList } from "../Slice/announcementSlice";

export function getAnnouncements() {
  return async function (dispatch, getState, { endpoint }) {
    const { data } = await axios.get(endpoint + API_ROUTES.GET_ANNOUNCEMENTS, {
      // headers
    });
    const slidingAnnouncements = data.data.filter((announcement) => announcement.announcement)
    dispatch(setAnnouncementList(data.data));
    dispatch(setSlidingAnnouncementList(slidingAnnouncements))
    return data;
  };
}

export function getDownloadCount() {
  return async function (dispatch, getState, { endpoint }) {
    const { data } = await axios.get(endpoint + API_ROUTES.GET_DOWNLOAD_COUNT, {
      // headers
    });
    dispatch(setCount(data.data));
    return data;
  };
}
